import React from 'react';
import '../shared/ordersShimmer.css';
import './OrderDetailsSkeleton.css';

const Shimmer: React.FC<{ className: string }> = ({ className }) => (
  <div className={`orders-shimmer ${className}`} aria-hidden />
);

const OrderDetailsSkeleton: React.FC = () => (
  <div className="order-details-skeleton" aria-busy="true" aria-label="Loading order details">
    <div className="order-details-layout">
      <div className="od-main">
        <div className="od-top-bar od-skeleton-top">
          <div className="od-skeleton-title-row">
            <Shimmer className="od-sk-title" />
            <Shimmer className="od-sk-pill" />
            <Shimmer className="od-sk-pill od-sk-pill--wide" />
          </div>
          <div className="od-skeleton-meta-row">
            <Shimmer className="od-sk-meta" />
            <Shimmer className="od-sk-meta od-sk-meta--short" />
            <Shimmer className="od-sk-meta" />
          </div>
        </div>

        <div className="od-items-card od-skeleton-card">
          <Shimmer className="od-sk-section-title" />
          <div className="od-sk-table-head">
            <Shimmer className="od-sk-th" />
            <Shimmer className="od-sk-th od-sk-th--qty" />
            <Shimmer className="od-sk-th od-sk-th--total" />
          </div>
          {[0, 1, 2].map((i) => (
            <div key={i} className="od-sk-item-row">
              <Shimmer className="od-sk-item-name" />
              <Shimmer className="od-sk-item-qty" />
              <Shimmer className="od-sk-item-total" />
            </div>
          ))}
        </div>

        <div className="od-summary-card od-skeleton-card">
          <Shimmer className="od-sk-section-title" />
          <div className="od-sk-summary-body">
            <Shimmer className="od-sk-summary-row" />
            <Shimmer className="od-sk-summary-row" />
            <Shimmer className="od-sk-summary-row od-sk-summary-row--total" />
          </div>
        </div>

        <div className="od-sk-actions">
          <Shimmer className="od-sk-action-btn" />
          <Shimmer className="od-sk-action-btn od-sk-action-btn--secondary" />
        </div>
      </div>
    </div>
  </div>
);

export default OrderDetailsSkeleton;
